import { ROOM_TYPE } from "../constants/roomConstants";
import { SILO_ROOM_TYPE } from '../constants/productConfiguratorConstants'

export const getProjectTypeLabel = (projectType) => {
  const map = {
    [ROOM_TYPE.ROOM]: 'Room Template',
    [ROOM_TYPE.LIFESTYLE]: 'Lifestyle',
    [ROOM_TYPE.SILO]: 'Silo',
    [ROOM_TYPE.VIGNETTE]: 'Vignette',
    [ROOM_TYPE.THREESIXTY]: '360 Web Viewer',
    [ROOM_TYPE.VIDEO]: 'Video',
    [ROOM_TYPE.CONFIGURATOR]: 'Configurator', 
    [ROOM_TYPE.AUGMENTED_REALITY]: 'Augumented Reality',
  }
  return map[projectType]
}

export const getFilterOptionsHelper = (filterOptions, disableCardAction, is360Configurator) => {
  const updatedFilterOptions = filterOptions
    .map((data) => {
      if (disableCardAction) {
        // check for string and number both
        // if 360 remove Lifestyle room
        if (!is360Configurator) {
          return data;
        } else {
          if (data.value === SILO_ROOM_TYPE) {
            return data;
          }
        }
      } else {
        return data;
      }
    })
    .filter((data) => data);
  return updatedFilterOptions;
};